import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// tslint:disable-next-line:max-line-length
import { Curriculum, Section, SemesterPlan, SectionSubjectPlans, WeeklyPlan, SemesterPlanWeek, WeeklyPlanPeriod, DailyPlan, SectionsPlans, LmsSectionSubject } from '../../_models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as _ from 'lodash';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';

@Injectable({
    providedIn: 'root'
})
export class PlanService {

    private apiUrl = `${environment.apiUrl}/Plan`;

    constructor(private http: HttpClient) {
    }


    getSectionSubjectPlans(sectionSubjectId: number): Observable<SectionSubjectPlans> {
        return this.http.get<SectionSubjectPlans>(`${this.apiUrl}/GetSectionSubjectPlans/${sectionSubjectId}`)
            .pipe(map(plans => {
                if (plans.semesterPlan)
                    this.setSemesterPlanDates(plans.semesterPlan);
                return plans;
            }));
    }

    getSemesterPlanSectionSubjectsWithSection(semesterPlanId: number): Observable<LmsSectionSubject[]> {
        return this.http.get<LmsSectionSubject[]>(`${this.apiUrl}/GetSemesterPlanSectionSubjectsWithSection/${semesterPlanId}`);
    }

    getSectionPlans(sectionId: number, sectionSubjectId: number = null): Observable<SectionsPlans> {
        return this.http.get<SectionsPlans>(`${this.apiUrl}/GetSectionPlans/${sectionId}${sectionSubjectId ? '/' + sectionSubjectId : ''}`);
    }

    getSemesterPlanByIdWithSectionSubjectsAndPlanWeeks(semesterPlanId: number): Observable<SemesterPlan> {
        return this.http.get<SemesterPlan>(`${this.apiUrl}/GetSemesterPlanByIdWithSectionSubjectsAndPlanWeeks/${semesterPlanId}`)
            .pipe(map(p => {
                this.setSemesterPlanDates(p);
                return p;
            }));
    }

    //#region Semester Plan
    addSemesterPlan(semesterPlan: SemesterPlan): Observable<SemesterPlan> {
        return this.http.post<SemesterPlan>(`${this.apiUrl}/AddSemesterPlan`, semesterPlan)
            .pipe(map(p => {
                this.setSemesterPlanDates(p);
                return p;
            }));
    }

    updateSemesterPlan(semesterPlan: SemesterPlan): Observable<SemesterPlan> {
        return this.http.put<SemesterPlan>(`${this.apiUrl}/UpdateSemesterPlan`, semesterPlan)
            .pipe(map(p => {
                this.setSemesterPlanDates(p);
                return p;
            }));
    }

    deleteSemesterPlan(semesterPlanId: number): Observable<SemesterPlan> {
        return this.http.delete<SemesterPlan>(`${this.apiUrl}/DeleteSemesterPlan/${semesterPlanId}`)
            .pipe(map(p => {
                this.setSemesterPlanDates(p);
                return p;
            }));
    }

    getWeeklyPlansBySemesterPlanWeekId(semesterPlanWeekId: number): Observable<WeeklyPlan[]> {
        return this.http.get<WeeklyPlan[]>(`${this.apiUrl}/GetWeeklyPlansBySemesterPlanWeekId/${semesterPlanWeekId}`);
    }

    //#endregion

    //#region Weekly Plan

 
    getSemesterPlanWeeksBySemesterPlanId(semesterPlanId: number): Observable<SemesterPlanWeek[]> {
        return this.http.get<SemesterPlanWeek[]>(`${this.apiUrl}/GetSemesterPlanWeeksBySemesterPlanId/${semesterPlanId}`)
            .pipe(map(weeks => {
                if (weeks && weeks.length > 0) {
                    _.forEach(week => {
                        this.setSemesterPlanWeekDates(week);
                    });
                }
                return weeks;
            }));
    }

    getWeeklyPlanByIdWithPeriods(weeklyPlanId: number): Observable<WeeklyPlan> {
        return this.http.get<WeeklyPlan>(`${this.apiUrl}/GetWeeklyPlanByIdWithPeriods/${weeklyPlanId}`);
    }

    addWeeklyPlan(weeklyPlan: WeeklyPlan): Observable<WeeklyPlan> {
        return this.http.post<WeeklyPlan>(`${this.apiUrl}/AddWeeklyPlan`, weeklyPlan);
    }

    updateWeeklyPlan(weeklyPlan: WeeklyPlan): Observable<WeeklyPlan> {
        return this.http.put<WeeklyPlan>(`${this.apiUrl}/UpdateWeeklyPlan`, weeklyPlan);
    }

    deleteWeeklyPlan(weeklyPlanId: number): Observable<WeeklyPlan> {
        return this.http.delete<WeeklyPlan>(`${this.apiUrl}/DeleteWeeklyPlan/${weeklyPlanId}`);
    }

    getWeeklyPlanStudents(weeklyPlanId: number): Observable<UserBasicInformation[]> {
        return this.http.get<UserBasicInformation[]>(`${this.apiUrl}/GetWeeklyPlanStudents/${weeklyPlanId}`);
    }

    getWeeklyPlanSections(weeklyPlanId: number): Observable<Section[]> {
        return this.http.get<Section[]>(`${this.apiUrl}/GetWeeklyPlanSections/${weeklyPlanId}`);
    }

    updateWeeklyPlanStudents(weeklyPlanId: number, studentsIds: string[]): Observable<WeeklyPlan> {
        return this.http.put<WeeklyPlan>(`${this.apiUrl}/UpdateWeeklyPlanStudents/${weeklyPlanId}`, studentsIds);
    }

    getWeeklyPlanPeriodByIdWithCurriculumItemsAndResources(weeklyPlanPeriodId: number): Observable<WeeklyPlanPeriod> {
        return this.http.get<WeeklyPlanPeriod>(
            `${this.apiUrl}/GetWeeklyPlanPeriodByIdWithCurriculumItemsAndResources/${weeklyPlanPeriodId}`);
    }

    updateWeeklyPlanPeriod(weeklyPlanPeriod: WeeklyPlanPeriod): Observable<WeeklyPlanPeriod> {

        if (weeklyPlanPeriod.useCurriculumItems)
            return this.http.put<WeeklyPlanPeriod>(`${this.apiUrl}/UpdateWeeklyPlanPeriod`, weeklyPlanPeriod);

        const formData: FormData = new FormData();
        if (weeklyPlanPeriod.files && weeklyPlanPeriod.files.length > 0) {
            for (let j = 0; j < weeklyPlanPeriod.files.length; j++) {
                formData.append('files', weeklyPlanPeriod.files[j], weeklyPlanPeriod.files[j].name);
            }
        }

        formData.append('weeklyPlanPeriodId', weeklyPlanPeriod.weeklyPlanPeriodId + '');
        formData.append('weeklyPlanId', weeklyPlanPeriod.weeklyPlanId + '');
        formData.append('useCurriculumItems', weeklyPlanPeriod.useCurriculumItems + '');
        formData.append('description', weeklyPlanPeriod.description ? weeklyPlanPeriod.description : '');
        formData.append('note', weeklyPlanPeriod.note ? weeklyPlanPeriod.note : '');
        formData.append('WeeklyPlanPeriodResourcesJson', JSON.stringify(weeklyPlanPeriod.weeklyPlanPeriodResources));

        return this.http.put<WeeklyPlanPeriod>(`${this.apiUrl}/UpdateWeeklyPlanPeriodForm`, formData);
    }
    //#endregion

    //#region Daily Plan
    getWeeklyPlansBySemesterPlanIdWithPeriods(semesterPlanId: number): Observable<WeeklyPlan[]> {
        return this.http.get<WeeklyPlan[]>(`${this.apiUrl}/GetWeeklyPlansBySemesterPlanIdWithPeriods/${semesterPlanId}`);
    }

    getDailyPlanByIdWithInnerData(dailyPlanId: number): Observable<DailyPlan> {
        return this.http.get<DailyPlan>(`${this.apiUrl}/GetDailyPlanByIdWithInnerData/${dailyPlanId}`);
    }

    addDailyPlan(dailyPlan: DailyPlan): Observable<DailyPlan> {
        return this.http.post<DailyPlan>(`${this.apiUrl}/AddDailyPlan`, dailyPlan);
    }

    updateDailyPlan(dailyPlan: DailyPlan): Observable<DailyPlan> {
        return this.http.put<DailyPlan>(`${this.apiUrl}/UpdateDailyPlan`, dailyPlan);
    }

    deleteDailyPlan(dailyPlanId: number): Observable<DailyPlan> {
        return this.http.delete<DailyPlan>(`${this.apiUrl}/DeleteDailyPlan/${dailyPlanId}`);
    }
    //#endregion

    private setSemesterPlanWeekDates(semesterPlanWeek: SemesterPlanWeek) {
        if (!semesterPlanWeek)
            return;

        if ((typeof semesterPlanWeek.startDate) === 'string' && String(semesterPlanWeek.startDate).length > 0)
            semesterPlanWeek.startDate = new Date(String(semesterPlanWeek.startDate));

        if ((typeof semesterPlanWeek.endDate) === 'string' && String(semesterPlanWeek.endDate).length > 0)
            semesterPlanWeek.endDate = new Date(String(semesterPlanWeek.endDate));
    }

    private setSemesterPlanDates(semesterPlan: SemesterPlan) {
        if (!semesterPlan)
            return;

        if (semesterPlan.startDate && (typeof semesterPlan.startDate) === 'string' && String(semesterPlan.startDate).length > 0)
            semesterPlan.startDate = new Date(String(semesterPlan.startDate));

        if (semesterPlan.endDate && (typeof semesterPlan.endDate) === 'string' && String(semesterPlan.endDate).length > 0)
            semesterPlan.endDate = new Date(String(semesterPlan.endDate));

        if (semesterPlan.semesterPlanWeeks && semesterPlan.semesterPlanWeeks.length > 0) {
            semesterPlan.semesterPlanWeeks.forEach(week => {

                if (week.startDate && (typeof week.startDate) === 'string' && String(week.startDate).length > 0)
                    week.startDate = new Date(String(week.startDate));

                if (week.endDate && (typeof week.endDate) === 'string' && String(week.endDate).length > 0)
                    week.endDate = new Date(String(week.endDate));
            });
        }
    }
}

